<template>
    <div>
        <el-dialog :visible.sync="dialogShow" width="919px" class="logisticsDialog-box" :close-on-click-modal="true"
            @close="closeDialog">
            <div class="dialog-member-title">
                <span class="dialog-member-name">反馈面试结果</span>
                <div class="dialog-close" @click="dialogShow = false">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="quan-num-add" v-loading="dataLoading">
                <div class="tool-btn">
                    <el-button type="primary" size="small" :disabled="!selectRows.length"  @click="multipleChangeStatus(true)">批量等待出签</el-button>
                    <el-button type="danger" size="small" :disabled="!selectRows.length"  @click="multipleChangeStatus(false)">批量拒签</el-button>
                </div>
                <!-- 面试表单 -->
                <el-table @selection-change="handleSelectionChange" :data="tableData"
                    style="width: 100%;margin: 10px 0px 0;box-sizing: border-box;" :header-cell-style="{
                        color: '#333',
                        backgroundColor: '#F2F4F7',
                        fontWeight: 'bold',
                        fontSize: '12px',
                    }">
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column prop="applicantName" label="申请人"></el-table-column>
                    <el-table-column prop="status" label="当前状态">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 14" type="wraning">{{ selectStatus(scope.row.status) }}</el-tag>
                            <el-tag v-else-if="scope.row.status == 17"  type="danger">{{ selectStatus(scope.row.status) }}</el-tag>
                            <el-tag  v-else type="success">{{ selectStatus(scope.row.status) }}</el-tag>

                        </template>
                    </el-table-column>
                    <el-table-column label="面试结果">
                        <template slot-scope="scope">
                            <div style="display: flex;align-items: center;gap: 10px;">
                                <el-link :underline="false" type="primary"
                                    @click="handleChangeStatus(true, scope.row)">等待出签</el-link>
                                <el-link :underline="false" type="danger"
                                    @click="handleChangeStatus(false, scope.row)">拒签</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination @current-change="currentChange" :current-page="page['Page.Index']"
                    @size-change="sizeChange" :page-sizes="[10, 20, 50, 100]" :page-size="page['Page.Size']"
                    layout="total, sizes, prev, pager, next, jumper" :total="page.total">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>


<script>
import { orderapplcantstatusselect, queryorderapplicants, orderapplicantmodifystatus } from "@/api/order.js";
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        orderItem: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            dialogShow: false,
            dataLoading: false,
            statusList: [],
            page: {
                "Page.Index": 1,
                "Page.Size": 10,
                OrderId: '',
                total:0
            },
            tableData: [

            ],
            selectRows: [],
        }
    },
    watch: {
        show(val) {
            this.dialogShow = val
            if (val) {
                this.page.OrderId = this.orderItem.id
                console.log(this.orderItem)
                this.handleGetStatus()
                this.handleGetApplicants()
            }
        },
    },
    methods: {
        currentChange(e) {
            this.page["Page.Index"] = e;
            this.handleGetApplicants();
        },
        sizeChange(e) {
            this.page["Page.Size"] = e;
            this.handleGetApplicants();
        },
        // 获取状态
        selectStatus(status) {
            return this.statusList.find(item => item.value == status).label
        },
        multipleChangeStatus(flage) {
            console.log(flage)
            // 确认操作
            this.$confirm('此操作将永久更改该状态, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log(this.selectRows)
                let data = this.selectRows.map(item => {
                    return {
                        "orderApplicantId": item.id, "status": flage ? 14 : 17
                    }
                })
                let proxy = data.map(item => {
                    return orderapplicantmodifystatus(item)
                })
                Promise.all(proxy).then(res => {
                    this.$message({
                        type: 'success',
                        message: '批量操作成功!'
                    })
                    this.handleGetApplicants()
                })
            }).catch(() => {
                this.$message({
                    type: 'success',
                    message: '批量操作失败!'
                })
                this.handleGetApplicants()
            })
        },
        handleChangeStatus(flage, item) {
            // 确认操作
            this.$confirm('此操作将永久更改该状态, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    "orderApplicantId": item.id, "status": flage ? 14 : 17
                }
                orderapplicantmodifystatus(data).then(res => {
                    if (res.code == 1) {
                        this.$message.success('操作成功')
                        this.handleGetApplicants()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => { })

        },
        handleSelectionChange(val) {
            this.selectRows = val
        },
        // 查询订单申请人
        handleGetApplicants() {
            queryorderapplicants(this.page).then(res => {
                if (res.code == 1) {
                    console.log(res)
                    this.tableData = res.data.rows
                    this.page.total = res.data.total
                }
            })
        },
        // 获取申请人可更改状态
        handleGetStatus() {
            orderapplcantstatusselect().then(res => {
                if (res.code == 1) {
                    console.log(res)
                    this.statusList = res.data
                }
            })
        },
        closeDialog() {
            this.$emit('closeDialog')
            this.dialogShow = false
            this.selectRows = []
            this.tableData = []
        }
    }

}

</script>



<style lang="scss" scoped>
.info_box {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .info_circle {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: #409EFF;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        font-weight: bold;
        color: #fff;
    }

    .info_text {
        display: flex;
        flex-direction: column;
    }

    .info_box_left {
        display: flex;
        align-items: center;
        gap: 20px;

        .info_box_text {
            display: flex;
            flex-direction: column;
            gap: 15px;
        }
    }

    .info_box_right {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }
}

.dialog-member-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -10px;

    .dialog-member-name {
        font-size: 18px;
        font-weight: bold;
    }

    .dialog-close {
        width: 25px;
        height: 25px;
        background: #e0e0e0;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .el-icon-close {
            color: #fff;
            font-size: 16px;
        }
    }
}

.tool-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    padding: 20px 30px 0;
}

.quan-num-add {
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 0 10px;
    margin-top: 10px;
    .quan-num-input {
        margin: 12px 0;
    }

    .quan-num-add-item {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .quan-num-add-title {
            font-size: 16px;
            margin-top: 12px;
        }

        .quan-num-right {
            margin-left: 16px;
            color: #3888e9;
            cursor: pointer;
        }
    }
}
</style>

<style lang="scss">
.logisticsDialog-box {
    .el-dialog {
        border-radius: 12px;
        margin-top: 5vh !important;
    }

    .el-dialog__header {
        display: none;
    }

    .el-dialog__body {
        background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
        border-radius: 12px;
        box-sizing: border-box;
        overflow: hidden;
    }
}
</style>